import { window } from "browser-monads"

/**
 * @returns {string}
 * @description returns pagePath
 */

export const getPagePath = () => {
  return window.location.href
}

/**
 * @returns {string}
 * @description returns hreflang abbreviation
 */

export const getHreflang = () => {
  const pagePath = getPagePath()
  if (pagePath.includes("/es")) return "es"
  if (pagePath.includes("/au")) return "en-au"
  if (pagePath.includes("/pt")) return "pt"
  if (pagePath.includes("/fr")) return "fr"
  if (pagePath.includes("/jp")) return "jp"
  return "en"
}

export const getLang = () => {
  const pagePath = getPagePath()
  if (pagePath.includes("/es")) return "es"
  if (pagePath.includes("/au")) return "au"
  if (pagePath.includes("/pt")) return "pt"
  if (pagePath.includes("/fr")) return "fr"
  if (pagePath.includes("/jp")) return "jp"
  return "en-us"
}
